import {
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../../context/AuthContext";
import { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import ShopCalendarEvent from "../../../ShopSchedule/ShopCalendar/ShopCalendarEvent";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const JobSchedule = ({ orderId }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const getScheduledEvents = async (orderId) => {
    try {
      setLoading(true);
      const res = await ezorder.get(`/shop/orders/${orderId}/schedule`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setCalendarEvents(res.data.calendarEvents);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getScheduledEvents(orderId);
  }, [orderId]);

  return (
    <Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left">Date</TableCell>
              <TableCell align="left">Time</TableCell>
              {/* <TableCell align="left">Workstation</TableCell> */}
              <TableCell align="left">Assigned To</TableCell>
              <TableCell align="left">Tasks</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {calendarEvents.map((event, index) => {
              let employeeNames = [];
              for (let employee of event.assignedTo) {
                employeeNames.push(employee.fullName);
              }

              let tasks = [];
              for (let subPhase of event.subPhases) {
                tasks.push(`${subPhase.phase.name} - ${subPhase.name}`);
              }

              return (
                <TableRow>
                  <TableCell align="left">
                    {dayjs(event.date).tz(DEFAULT_TIMEZONE).format("MM/DD/YY")}
                  </TableCell>
                  <TableCell align="left">
                    {dayjs(event.startDate)
                      .tz(DEFAULT_TIMEZONE)
                      .format("h:mm a")}{" "}
                    -{" "}
                    {dayjs(event.endDate).tz(DEFAULT_TIMEZONE).format("h:mm a")}
                  </TableCell>

                  {/* <TableCell align="left">
                    {event.workStation ? event.workStation.name : ""}
                  </TableCell> */}
                  <TableCell align="left">{employeeNames.join(", ")}</TableCell>
                  <TableCell align="left">
                    {/* {tasks.map((task) => (
                      <Typography>{task}</Typography>
                    ))} */}
                    {event.eventNotes}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default JobSchedule;
